import http from '@/utils/http';
import { OVERDUE_REASONS_FORCE_CONTROL_REMINDER_QUERY_URL } from '@/config/overdueReasonsForceControlReminder';

export interface OverduePopupData {
  overdueTaskCount: number;
  taskNoList: string[];
}

export interface OverduePopupResponse {
  code: number | string;
  msg?: string;
  data?: OverduePopupData;
}

/** 查询物流逾期未关单弹窗数据（逾期原因强控） */
export function queryOverduePopup(): Promise<OverduePopupResponse> {
  return http({
    url: OVERDUE_REASONS_FORCE_CONTROL_REMINDER_QUERY_URL,
    method: 'get',
    showProgress: false,
  } as any) as Promise<OverduePopupResponse>;
}
